"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWhyDidYouUpdate = void 0;
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
function useWhyDidYouUpdate(name, props) {
    // Get a mutable ref object where we can store props ...
    // ... for comparison next time this hook runs.
    const previousProps = react_1.useRef();
    react_1.useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            if (previousProps.current) {
                // Get all keys from previous and current props
                const allKeys = Object.keys({ ...previousProps.current, ...props });
                // Use this object to keep track of changed props
                const changesObj = {};
                // Iterate through keys
                allKeys.forEach(key => {
                    if (previousProps.current) {
                        // If previous is different from current
                        if (previousProps.current[key] !== props[key]) {
                            // Add to changesObj
                            changesObj[key] = {
                                from: previousProps.current[key],
                                to: props[key],
                                diff: lodash_1.default.differenceBy(previousProps.current[key], props[key], lodash_1.default.isEqual)
                            };
                        }
                    }
                });
                // If changesObj not empty then output to console
                if (Object.keys(changesObj).length) {
                    //eslint-disable-next-line no-console
                    console.log("[why-did-you-update]", name, changesObj);
                }
            }
            // Finally update previousProps with current props for next hook call
            previousProps.current = props;
        }
    });
}
exports.useWhyDidYouUpdate = useWhyDidYouUpdate;
//# sourceMappingURL=useWhyDidYouUpdate.js.map